import { ZoomSetting } from '@/api/openapi';
import { ZoomSettingApiService } from '@/api/user/resources/zoom_setting';
import ZoomSettingStatuses from '@/const/zoom_setting_statuses';
import store from '@/store/index';
import { TCtiType, CTI_TYPES } from '@/types';

const AUTH_DELETE_ACTIONS: Record<TCtiType, () => Promise<void>> = {
  zoom: async () => {
    await turnOffZoomPhoneUsing();
  },
  miitel: async () => {
    await store.dispatch('user/deleteMiitelAuthAction');
  },
};

const getZoomSetting = async (): Promise<ZoomSetting> => {
  const api = new ZoomSettingApiService();
  const { data: { zoomSetting } } = await api.getZoomSetting();
  return zoomSetting;
};

const getIsUsingZoomPhone = async (): Promise<boolean> => {
  const zoomSetting = await getZoomSetting();
  return !!zoomSetting.useZoomPhone;
};

const getIsZoomPhoneConnected = async (): Promise<boolean> => {
  const zoomSetting = await getZoomSetting();
  return zoomSetting.apiSetting?.connectStatus === ZoomSettingStatuses.CONNECTED;
};

const turnOffZoomPhoneUsing = async (): Promise<void> => {
  const api = new ZoomSettingApiService();
  await api.updateZoomSetting({
    request: {
      updateZoomSettingBody: {
        useZoomPhone: false,
      },
    },
  });
};

/**
 * 接続確認
 */
const isUsing: Record<TCtiType, () => Promise<boolean>> = {
  zoom: async (): Promise<boolean> => {
    return await getIsUsingZoomPhone();
  },
  miitel: async (): Promise<boolean> => {
    await store.dispatch('user/getMiitelAuthAction');
    const miitelAuth = store.state.user.miitelAuth;
    return !!miitelAuth?.companyId || !!miitelAuth?.accessKey;
  },
};

/**
 * 指定したCTI以外を接続解除
 */
const unconnectAllExcept = async (target: TCtiType): Promise<void> => {
  for (const currentTarget of CTI_TYPES) {
    if (currentTarget === target) {
      continue;
    }

    const using = await isUsing[currentTarget]();
    if (!using) {
      continue;
    }
    const action = AUTH_DELETE_ACTIONS[currentTarget];
    await action();
  }
};

export {
  getIsZoomPhoneConnected,
  unconnectAllExcept,
};
